import { GoogleTagManager } from '@next/third-parties/google';

export default function GTMComponent() {
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID || 'GTM-KCK8QJLD';
  
  return <GoogleTagManager gtmId={gtmId} />;
}
